import groupBy from 'lodash/groupBy';
import { MarketInfo } from './types';

export function validateSameMatchTeasers(marketsWithInfo: Record<number, MarketInfo>) {
    const teaserMarketsByMatch = groupBy(Object.values(marketsWithInfo), 'match_id');
    return Object.values(teaserMarketsByMatch)
        .filter((markets) => markets.length > 1 && !markets[0].sameMatchTeaserAllowed)
        .flatMap((markets) => markets.map((mr) => mr.id));
}
